/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_PrivacyInputs */



/**
* | output |
* | --- |
* | "You are speaking with a fictional character, even when a practice conversation is based on a real one. What you say stays with you: it is not shared with you..." |
*
* @param {Practice_PrivacyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_privacy = /** @type {((inputs?: Practice_PrivacyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_PrivacyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je spreekt met een fictief personage, ook wanneer een oefengesprek op een echt gesprek is afgestemd. Wat je zegt blijft bij jou: het wordt niet gedeeld met je teamlid en niet toegevoegd aan het geheugen van je team.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous parlez à un personnage fictif, même lorsqu'un entretien d'entraînement s'appuie sur un entretien réel. Ce que vous dites reste privé : ce n'est pas partagé avec votre collaborateur ni ajouté à la mémoire de votre équipe.")
	return /** @type {LocalizedString} */ ("You are speaking with a fictional character, even when a practice conversation is based on a real one. What you say stays with you: it is not shared with your team member and not added to your team's memory.")
});